import { TableV2 } from '@anytag/shared-atoms';
import { TwitterAnalyticsPostItemPayload } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerTwitterAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsTwitterPostsListTable } from './hooks';

export interface AnalyticsTwitterPostsListProps extends TableData<TwitterAnalyticsPostItemPayload> {
  mainSocialAccountId?: number;
}

export const AnalyticsTwitterPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsTwitterPostsListProps) => {
  const { columns } = useAnalyticsTwitterPostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerTwitterAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
